import React, { useEffect, useRef } from 'react'
import { Container, Row, Col } from 'react-bootstrap-v5'
import './Sedes.css'
import MapaFDNA from './MapaFDNA'

interface Sede {
  nombre: string
  direccion: string
  correo: string
}

const sedes: Sede[] = [
  {
    nombre: 'Guatemala',
    direccion: 'Interior Estadio Nacional Doroteo Guamuch Flores, Zona 5, Ciudad de Guatemala',
    correo: 'informacion@fdna.gt'
  },
  {
    nombre: 'Alta Verapaz',
    direccion: 'Casa del Deportista, 2da. Calle 2-73 Zona 4, Cobán A.V.',
    correo: 'asoaltaverapaz@fdna.gt'
  },
  {
    nombre: 'Baja Verapaz',
    direccion: 'Villa Deportiva 2da. Avenida 6-89 Zona 1, Salamá',
    correo: 'asobajaverapaz@fdna.gt'
  },
  {
    nombre: 'Chiquimula',
    direccion: 'Casa del Deportista 8va. Av. Sur Final, Zona 1',
    correo: 'asochiquimula@fdna.gt'
  },
  {
    nombre: 'Chimaltenango',
    direccion: 'Casa del Deportista 1ra. Calle 9-23 Zona 4',
    correo: 'asochimaltenango@fdna.gt'
  },
  {
    nombre: 'Izabal',
    direccion: 'Casa del Deportista 14 Calle y 12 Av. esquina, Puerto Barrios',
    correo: 'asoizabal@fdna.gt'
  },
  {
    nombre: 'Jutiapa',
    direccion: 'Casa del Deportista 5ta. Calle, La Randa Casa No. 1-53 Zona 1',
    correo: 'asojutiapa@fdna.gt'
  },
  {
    nombre: 'Jalapa',
    direccion: 'Complejo Deportivo Ramiro Lucas García Km. 2.5 salida a Sanarate',
    correo: 'asojalapa@fdna.gt'
  },
  {
    nombre: 'Quetzaltenango',
    direccion: 'Casa del Deportista 1ra. Calle 12-44 Zona 3',
    correo: 'asoquetzaltenango@fdna.gt'
  },
  {
    nombre: 'Petén',
    direccion: 'Complejo Deportivo Santa Elena',
    correo: 'asopeten@fdna.gt'
  },
  {
    nombre: 'Escuintla',
    direccion: 'Complejo Deportivo Km. 54.9 carretera al Pacífico',
    correo: 'asoescuintla@fdna.gt'
  },
  {
    nombre: 'El Progreso',
    direccion: 'Barrio El Porvenir, Guastatoya',
    correo: 'asoelprogreso@fdna.gt'
  },
  {
    nombre: 'Huehuetenango',
    direccion: 'Villa Deportiva Calle Real, Zona 8 El Hipódromo',
    correo: 'asohuehuetenango@fdna.gt'
  },
  {
    nombre: 'Retalhuleu',
    direccion: 'Km. 186.5 salida a Champerico, Zona 5',
    correo: 'asoretalhuleu@fdna.gt'
  },
  {
    nombre: 'Sacatepéquez',
    direccion: 'Carretera a San Felipe, frente a Colonia Manchen, Antigua',
    correo: 'asosacatepequez@fdna.gt'
  },
  {
    nombre: 'Totonicapán',
    direccion: '4ta. Calle 4 Av. Zona 1',
    correo: 'asototonicapacan@fdna.gt'
  },
  {
    nombre: 'San Marcos',
    direccion: 'Villa Deportiva 6ta. Av. B 12-114 Zona 1',
    correo: 'asosanmarcos@fdna.gt'
  },
  {
    nombre: 'Zacapa',
    direccion: 'Casa del Deportista 15 Av. B-11 Zona 1 Barrio La Laguna',
    correo: 'asozacapa@fdna.gt'
  },
  {
    nombre: 'Sololá',
    direccion: 'Casa del Deportista 14 Calle 5-74 Zona 1',
    correo: 'asosolola@fdna.gt'
  },
  {
    nombre: 'Santa Rosa',
    direccion: 'Casa del Deportista Iván R. Las Delicias, Cuilapa',
    correo: 'asosantarosa@fdna.gt'
  },
  {
    nombre: 'Quiché',
    direccion: '1ra. Av. 12 Calle Zona 5, Santa Cruz del Quiché',
    correo: 'asoquiche@fdna.gt'
  },
  {
    nombre: 'Suchitepéquez',
    direccion: 'Avenida del Estadio, Mazatenango',
    correo: 'asosuchitepequez@fdna.gt'
  }
]

export default function Sedes() {
  const pageRef = useRef<HTMLDivElement>(null)

  const getInitials = (nombre: string) => {
    const words = nombre.trim().split(' ')
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase()
    }
    return `${words[0][0] ?? ''}${words[1][0] ?? ''}`.toUpperCase()
  }

  useEffect(() => {
    if (pageRef.current) {
      pageRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  return (
    <div ref={pageRef} className='sedes-container py-20'>
      <Container>
        <div className='sedes-hero'>
          <div className='sedes-hero-badge'>Red nacional</div>
          <h1 className='sedes-hero-title'>Sedes de Entrenamiento</h1>
          <p className='sedes-hero-copy'>
            Ubicaciones y contactos oficiales para encontrar la sede más cercana. Contamos con presencia en todos los departamentos del país.
          </p>

          <div className='sedes-hero-ribbon'>
            Sede principal: Interior Estadio Nacional Doroteo Guamuch Flores, Zona 5, Ciudad de Guatemala.
          </div>

          <div className='sedes-hero-stats'>
            <div className='sedes-stat'>
              <strong>{sedes.length}</strong>
              <span>sedes registradas</span>
            </div>
            <div className='sedes-stat'>
              <strong>22 departamentos</strong>
              <span>hay sede en todos</span>
            </div>
            <div className='sedes-stat'>
              <strong>Contacto</strong>
              <span>correo directo por sede</span>
            </div>
          </div>
        </div>

        <Row className='mb-4'>
          <Col xs={12}>
            <div className='section-panel'>
              <div className='section-panel-header mb-4'>
                <div>
                  <p className='section-kicker'>Mapa de referencia</p>
                  <h2 className='section-title'>Guatemala por departamentos</h2>
                </div>
              </div>

              <MapaFDNA />

              
            </div>
          </Col>
        </Row>

        <Row className='mb-20'>
          <Col xs={12}>
            <div className='section-panel section-panel-soft mb-4'>
              <div className='section-panel-header'>
                <div>
                  <p className='section-kicker'>Listado completo</p>
                  <h2 className='section-title'>Directorio de sedes</h2>
                </div>
                <span className='section-counter'>{sedes.length} ubicaciones</span>
              </div>

              <Row className='g-4'>
                {sedes.map((sede, index) => (
                  <Col key={index} xs={12} md={6} lg={4}>
                    <div
                      className={`sede-card sede-card-${(index % 4) + 1}`}
                      style={{ animationDelay: `${index * 45}ms` }}
                    >
                      <div className='sede-card-header'>
                        <div className='sede-icon'>{getInitials(sede.nombre)}</div>
                        <div>
                          <h3 className='sede-title'>{sede.nombre}</h3>
                          <span className='sede-chip'>
                            {sede.nombre.includes('Sede Principal') ? 'Sede principal' : 'Federación departamental'}
                          </span>
                        </div>
                      </div>

                      <div className='sede-card-body'>
                        <div className='sede-info-item'>
                          <span className='sede-label'>Dirección</span>
                          <p className='sede-value'>{sede.direccion}</p>
                        </div>

                        <div className='sede-info-item'>
                          <span className='sede-label'>Correo</span>
                          <a href={`mailto:${sede.correo}`} className='sede-email'>
                            {sede.correo}
                          </a>
                        </div>
                      </div>

                      <div className='sede-card-footer'>
                        <a href={`mailto:${sede.correo}`} className='btn btn-sm btn-primary w-100'>
                          Contactar sede
                        </a>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>

        {/* Contact Section */}
        <Row className='mt-20 pt-20 border-top'>
          <Col xs={12}>
            <div className='contact-section'>
              <h2 className='text-center fw-bold fs-2 mb-10'>¿Necesitas más información?</h2>
              <p className='text-center fs-5 mb-10'>
                Contáctanos a través del correo general de la Federación
              </p>
              <div className='text-center'>
                <a href='mailto:informacion@fdna.gt' className='btn btn-lg btn-primary'>
                  Enviar Correo
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
